import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="fixed top-4 right-4 z-50 bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 py-2 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 font-semibold"
      data-testid="language-toggle"
    >
      {language === 'tr' ? '🇬🇧 EN' : '🇹🇷 TR'}
    </button>
  );
};

export default LanguageToggle;